
import { Component, Vue } from "vue-property-decorator";

import program_routes from "@/api/routes/programs";

export interface IDeletingProgramAssignment {
  id: string;
  assignment_index: number;
}

export interface IDeletedProgramAssignment {
  assignment_index: number;
}

@Component({
  name: "CProgramAssignmentsDelete"
})
export default class CProgramAssignmentsDelete extends Vue {
  private deleting: IDeletingProgramAssignment | null = null;

  private watchers: Function[] = [];

  protected beforeDestroy() {
    this.watchers.forEach(unwatch => {
      unwatch();
    });
  }

  protected created() {
    this.watchers.push(
      this.$store.watch(
        state => state.deletingProgramAssignment,
        (deletingProgramAssignment: IDeletingProgramAssignment | null) => {
          this.deleting = deletingProgramAssignment;

          if (this.deleting) {
            this.showModal();
          }
        }
      )
    );
  }

  public async deleteAssignment() {
    if (!this.deleting) {
      return;
    }

    return this.$api
      .destroy(program_routes.assignment(this.deleting.id))
      .then(() => {
        this.$store.commit("deletedProgramAssignment", {
          assignment_index: this.deleting?.assignment_index
        });

        this.hideModal();

        this.$notify({
          group: "notifications",
          type: "success",
          text: "Назначение удалено",
          speed: 500
        });
      })
      .catch(({ response: res }) => {
        this.$notify({
          group: "notifications",
          type: "error",
          text: res.data.error,
          speed: 500
        });
      });
  }

  public showModal() {
    this.$modal.show("delete_program_assignment");
  }

  public hideModal() {
    this.$modal.hide("delete_program_assignment");

    this.$store.commit("deletingProgramAssignment", null);
  }

  public allowWrite() {
    return this.$api.allowWrite();
  }
}
